import userDropdown from '@/components/app/header/user-dropdown/user-dropdown.vue'
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  components: {
    userDropdown
  },
  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/app/header/subpage-header/subpage-header.js